// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._37ism{font-size:16px;font-size:1.6rem;font-weight:700;line-height:36px;line-height:3.6rem}@media (min-width:600px){._37ism{font-size:2rem}}@media (min-width:1024px){._37ism{font-size:2.4rem}}._2yBHh{max-height:144px}", ""]);
// Exports
exports.locals = {
	"email": "_37ism",
	"mainImage": "_2yBHh"
};
module.exports = exports;
